/**
 * @generated SignedSource<<46e91638091abe63f5678cf189e1f185>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioRef$data = {
  readonly " $fragmentSpreads": FragmentRefs<"webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillDataComponent_scenarioRef">;
  readonly " $fragmentType": "knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioRef";
};
export type knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioRef$key = {
  readonly " $data"?: knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillDataComponent_scenarioRef"
    }
  ],
  "type": "AgentStudioScenario",
  "abstractKey": "__isAgentStudioScenario"
};

(node as any).hash = "6299c142b625a5f46de323f30bb31458";

export default node;
